// Footer.js
//PaginatedItems에 있었음

import React from 'react';
import './Footer.scss'; 
import logoFooter from './images/logo_footer.png'; // 이미지 파일의 위치에 따라 경로를 수정하세요.


function Footer() {
  return (
    <footer className="footer">
      {/* <div className='flex flex-wrap'>
       <img src={logoFooter} alt="Logo" style={{ marginRight: '1rem' }} />
      <div className="footer-content">
        <div className="footer-section">
          <span>042-821-1902 Fax 042-821-1585</span>
        </div>
        <div className="footer-section address">
          <span>[34158] 대전광역시 유성구 동서대로 125(덕명동) 한밭대학교</span>
        </div>
      </div>
      </div> */}
      <p>@ 2025 아이공 프로젝트</p>
    </footer>
  );
}

export default React.memo(Footer);
